import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Box, Button, Grid, Typography } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import activeFlagg from "../../Assets/Table/Flag-active.svg";
import disabledFlagg from "../../Assets/Table/Flag-desabled.svg";
import editIcon from "../../Assets/Table/edit-icon.svg";
import deleteIcon from "../../Assets/Table/delete-icon.svg";
import { checkPermission } from "../../Utils/Permissions";

const DataTable = ({
  tableHeader,
  data,
  isModal,
  isCity,
  handleEdit,
  handleCheckboxChange,
  handleFlaggChange,
  checkedItems,
  handleDelete,
  onClick,
  isStatus,
  flaggedItems,
  isDelete,
  isApproval,
  isEdit,
}) => {
  return (
    <TableContainer
      sx={{ boxShadow: "rgba(149, 157, 165, 0.1) 0px 2px 14px;" }}
      component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          {tableHeader.map((title) => {
            return (
              <TableRow>
                <TableCell sx={{ color: "#4e5c6c", fontWeight: 600 }}>
                  {title.headText1}
                </TableCell>
                <TableCell sx={{ color: "#4e5c6c", fontWeight: 600 }}>
                  {title.headText2}
                </TableCell>
                {title.headText6 && (
                  <TableCell sx={{ color: "#4e5c6c", fontWeight: 600 }}>
                    {title.headText6}
                  </TableCell>
                )}
                <TableCell sx={{ color: "#4e5c6c", fontWeight: 600 }}>
                  {title.headText3}
                </TableCell>
                {title.headText4 && (
                  <TableCell sx={{ color: "#4e5c6c", fontWeight: 600 }}>
                    {title.headText4}
                  </TableCell>
                )}
                <TableCell sx={{ color: "#4e5c6c", fontWeight: 600 }}>
                  {title.headText5}
                </TableCell>
              </TableRow>
            );
          })}
        </TableHead>
        <TableBody>
          {data &&
            data?.map((rowItem) => {
              return (
                <TableRow
                  onClick={() => onClick(rowItem)}
                  key={rowItem.id}
                  sx={{
                    "&:last-child td, &:last-child th": {
                      border: 0,
                    },
                  }}>
                  <TableCell component="th" scope="row">
                    <Grid container alignItems={"center"}>
                      {rowItem?.image && (
                        <Box
                          component={"img"}
                          src={rowItem.image}
                          sx={{
                            width: 30,
                            height: 30,
                            marginRight: "10px ",
                            borderRadius: "4px",
                          }}
                        />
                      )}
                      {rowItem.cellItem1}
                    </Grid>
                  </TableCell>

                  <TableCell sx={{ height: 25 }}>{rowItem.cellItem2}</TableCell>
                  {rowItem.cellItem5 && (
                    <TableCell sx={{ height: 25 }}>
                      {rowItem.cellItem5}
                    </TableCell>
                  )}
                  {isCity && (
                    <TableCell sx={{ height: 25 }}>
                      {rowItem.cellItem3}
                    </TableCell>
                  )}
                  {isCity ? (
                    <TableCell>
                      <Grid
                        container
                        width={"120px"}
                        alignItems={"center"}
                        height={"30px"}>
                        {/* {isApproval && (
                          <Checkbox
                            checked={rowItem?.cellItem4 || false}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleCheckboxChange(e, rowItem.id);
                            }}
                            inputProps={{ "aria-label": "controlled" }}
                            value={rowItem.id}
                          />
                        )} */}
                        {rowItem?.cellItem4 ? "Approved" : "Pending"}
                      </Grid>
                    </TableCell>
                  ) : (
                    <TableCell>
                      <Grid
                        container
                        width={"120px"}
                        alignItems={"center"}
                        height={"30px"}>
                        {/* {isApproval && (
                          <Checkbox
                            checked={rowItem?.cellItem3 || false}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleCheckboxChange(e, rowItem.id);
                            }}
                            inputProps={{ "aria-label": "controlled" }}
                            value={rowItem.id}
                          />
                        )} */}
                        {rowItem.cellItem3 ? "Approved" : "Pending"}
                      </Grid>
                    </TableCell>
                  )}
                  {!isCity && (
                    <TableCell>
                      <Grid
                        sx={{
                          height: "10px",
                          display: "flex",
                          alignItems: "center",
                        }}>
                        {/* {isStatus && (
                          <Checkbox
                            checked={rowItem.cellItem4 == "FLAGGED" || false}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleFlaggChange(e, rowItem.id);
                            }}
                            inputProps={{ "aria-label": "controlled" }}
                            value={rowItem.id}
                            // onClick={() =>
                            //   !flaggedItems.includes(rowItem.id)
                            //     ? isModal({ isOpen: false, data: flagData })
                            //     : null
                            // }
                          />
                        )} */}
                        {rowItem.cellItem4 == "FLAGGED" ? (
                          <Grid container width={"100px"}>
                            <Box component={"img"} src={activeFlagg}></Box>
                            <Typography marginLeft={"10px"} color={"#fa6450"}>
                              Flagged
                            </Typography>
                          </Grid>
                        ) : (
                          <Grid container width={"100px"}>
                            <Box component={"img"} src={disabledFlagg}></Box>
                            <Typography marginLeft={"10px"} color={"#17dfba"}>
                              Good
                            </Typography>
                          </Grid>
                        )}
                      </Grid>
                    </TableCell>
                  )}
                  <TableCell>
                    {/* <Grid container width={"140px"}>
                      {isEdit && (
                        <Button
                          onClick={(e) => {
                            e.stopPropagation();
                            handleEdit(rowItem);
                          }}>
                          <Box component={"img"} src={editIcon} />
                        </Button>
                      )}
                      {isDelete && (
                        <Button
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDelete(rowItem.id);
                          }}>
                          <Box component={"img"} src={deleteIcon} />
                        </Button>
                      )}
                    </Grid> */}
                  </TableCell>
                </TableRow>
              );
            })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
export default DataTable;
